import { paymentsV2GetterTypes } from './types'

const getters = {
    [paymentsV2GetterTypes.GET_PAYMENT_TYPES]: (state) => state.payment_types,
    [paymentsV2GetterTypes.GET_BANK_CODES]: (state) => state.bank_codes,
    [paymentsV2GetterTypes.GET_PAYMENTS]: (state) => state.payments,
    [paymentsV2GetterTypes.GET_CLIENT]: (state) => state.client,
    [paymentsV2GetterTypes.GET_LOADING]: (state) => state.loading,
}

export default getters
